import axios from 'axios';
import {setInterceptor} from './interceptor.js';

export function createInstance(timeout = 10 * 1000, customHeader = null) {
  const instance = axios.create({
    // baseURL: 'http://localhost:8080/',
  });
  instance.defaults.timeout = timeout;
  return setInterceptor(instance, customHeader);
}
